export const formatPdfValue = (value) => {
  if (value === null || value === undefined || value === "") return "-";
  return String(value);
};

const normalizePdfText = (value, preserveLineBreaks = false) => {
  const rawText = formatPdfValue(value).replace(/\r\n?/g, "\n");
  const text = preserveLineBreaks
    ? rawText
        .split("\n")
        .map((line) => line.replace(/\s+/g, " ").trim())
        .filter(Boolean)
        .join("\n")
    : rawText.replace(/\s+/g, " ").trim();

  return text || "-";
};

const wrapLongSegment = (segment, maxLength = 18) => {
  if (segment.length <= maxLength) return segment;

  const parts = [];
  for (let index = 0; index < segment.length; index += maxLength) {
    parts.push(segment.slice(index, index + maxLength));
  }

  return parts.join("\n");
};

const wrapLongToken = (token, maxLength = 18) => {
  if (token.length <= maxLength) return token;

  const lines = [];
  let currentLine = "";
  const parts = token
    .split(/([@._/-])/)
    .filter((part) => part !== "");

  parts.forEach((part) => {
    const chunks = wrapLongSegment(part, maxLength).split("\n");

    chunks.forEach((chunk) => {
      if (!currentLine) {
        currentLine = chunk;
        return;
      }

      if (currentLine.length + chunk.length > maxLength) {
        lines.push(currentLine);
        currentLine = chunk;
        return;
      }

      currentLine += chunk;
    });
  });

  if (currentLine) {
    lines.push(currentLine);
  }

  return lines.join("\n");
};

export const formatPdfCellValue = (value, column = {}) => {
  if (
    column.pdfBlankWhenEmpty &&
    (value === null || value === undefined || value === "")
  ) {
    return "";
  }

  const text = normalizePdfText(value, column.pdfPreserveLineBreaks);
  const wrapLength = column.pdfWrapLength || 18;

  if (text === "-") return text;

  return text
    .split("\n")
    .map((line) =>
      line
        .split(" ")
        .map((part) =>
          part.length <= wrapLength ? part : wrapLongToken(part, wrapLength),
        )
        .join(" "),
    )
    .join("\n")
    .replace(/\n\s+/g, "\n")
    .replace(/\n{2,}/g, "\n");
};
